// Central asset & content configuration for P&P Gartenservice
export const ASSETS = {
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_6382a13c-cf58-46fe-ab9d-2b701b127c0f/artifacts/bg630vrm_486e2059-da9d-467a-a1f5-475868aeab1d.jpeg",
  flyerOwners: "https://customer-assets-jt897jd0.emergentagent.net/job_6382a13c-cf58-46fe-ab9d-2b701b127c0f/artifacts/u8yrps3w_0322f402-24d4-44d8-8614-5129fa7daf0a.jpeg",
  bench: "https://customer-assets-jt897jd0.emergentagent.net/job_6382a13c-cf58-46fe-ab9d-2b701b127c0f/artifacts/hznoz2zs_d66b8675-a3dd-4585-ab24-03ed60a19018.jpeg",
  hedgeAlley: "https://customer-assets-jt897jd0.emergentagent.net/job_6382a13c-cf58-46fe-ab9d-2b701b127c0f/artifacts/qilaphxt_0d8f7388-caf4-4fc8-9815-667ab750b375.jpeg",
  poolTerrace: "https://customer-assets-jt897jd0.emergentagent.net/job_6382a13c-cf58-46fe-ab9d-2b701b127c0f/artifacts/k4vrs98k_e7888612-2d8a-417d-949d-90ac094088dc.jpeg",
};

export const CONTACT = {
  phone: "015140367062",
  phoneIntl: "+4915140367062",
  whatsappHref: "https://wa.me/4915140367062?text=Hallo%20P%26P%20Gartenservice%2C%20ich%20interessiere%20mich%20f%C3%BCr%20Ihre%20Leistungen.",
  telHref: "tel:+4915140367062",
  email: "pundpgartenservice@gmail.com",
  emailHref: "mailto:pundpgartenservice@gmail.com",
  instagram: "https://www.instagram.com/pundpgartenservice?igsh=Nzd0NDIzemU1c3Nt",
  serviceArea: "Grünberg und Umgebung · 15 km Umkreis",
};

export const SERVICES = [
  { id: "01", title: "Rasen mähen", desc: "Regelmäßige Pflege für einen dichten, satten Grünteppich." },
  { id: "02", title: "Hecken schneiden", desc: "Klare Linien, saubere Kanten, gesundes Wachstum." },
  { id: "03", title: "Unkraut entfernen", desc: "Beete und Wege dauerhaft frei und gepflegt." },
  { id: "04", title: "Beetpflege", desc: "Lockern, mulchen, düngen — Ihre Pflanzen atmen auf." },
  { id: "05", title: "Laub entfernen", desc: "Herbstpflege, damit Ihr Rasen den Winter übersteht." },
  { id: "06", title: "Terrassen & Wege reinigen", desc: "Moos, Grünbelag und Schmutz — gründlich entfernt." },
  { id: "07", title: "Grünschnitt entsorgen", desc: "Wir nehmen den Schnitt gleich mit. Kein Aufwand für Sie." },
  { id: "08", title: "Kleine Pflanzarbeiten", desc: "Neue Stauden, Sträucher oder Blumen — fachgerecht gesetzt." },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Zuverlässig",
    body: "Wenn wir einen Termin machen, sind wir da. Pünktlich, vorbereitet, mit einem klaren Plan für Ihren Garten.",
  },
  {
    n: "02",
    title: "Sauber",
    body: "Wir hinterlassen keinen Schnitt, keinen Dreck, keinen Ärger. Nur einen Garten, der aussieht, als wäre gerade Frühling.",
  },
  {
    n: "03",
    title: "Fair",
    body: "Ehrliche Preise, transparent kalkuliert. Kostenlose Besichtigung, Angebot ohne Verpflichtung.",
  },
];
